<app-inspire-hero></app-inspire-hero>
<app-inspire-presentation></app-inspire-presentation>
<app-other-histories></app-other-histories>
<app-arrived-now></app-arrived-now>
<app-discover></app-discover>
<app-category-news></app-category-news>
<app-depositions></app-depositions>
<app-donors></app-donors>